import React from "react";

function StoryRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g
        id="Story_Right_Icon"
        data-name="Story Right Icon"
        transform="translate(-1107.031 -134.031)"
      >
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="15"
          cy="15"
          r="15"
          transform="translate(1107.031 134.031)"
          fill="rgba(255,255,255,0.86)"
          opacity="0.5"
        />
        <path
          id="Icon_akar-chevron-left"
          data-name="Icon akar-chevron-left"
          d="M10.5,6l3.25,3.25L16.5,12l-6,6"
          transform="translate(1108.281 136.781)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default StoryRight;
